export default "__VITE_ASSET__CE_84o2___"